import { normalizeCanvasSearch } from "src/components/TeamCanvas/teamCanvasPresentation";

const COMPARE_FROM_KEY = "compareFrom";
const COMPARE_TO_KEY = "compareTo";

/** URL token for trunk (no overlay). Real option ids are never this string. */
export const DESIGN_COMPARE_TRUNK = "current";

export const optionIdToCompareToken = (optionId?: string | null) =>
  optionId || DESIGN_COMPARE_TRUNK;

const compareTokenToOptionId = (token?: string | null): string | null =>
  !token || token === DESIGN_COMPARE_TRUNK ? null : token;

export type DesignOptionCompareState =
  | { active: false }
  | {
      active: true;
      fromToken: string;
      toToken: string;
      fromOptionId: string | null;
      toOptionId: string | null;
    };

/**
 * Option compare is URL-backed so a view can be shared.
 * Both params present → compare on. Omit both → edit the switched option.
 */
export const parseDesignOptionCompare = (
  search?: string | null
): DesignOptionCompareState => {
  const params = new URLSearchParams(normalizeCanvasSearch(search));
  const fromToken = params.get(COMPARE_FROM_KEY);
  const toToken = params.get(COMPARE_TO_KEY);
  if (!fromToken || !toToken) {
    return { active: false };
  }
  return {
    active: true,
    fromToken,
    toToken,
    fromOptionId: compareTokenToOptionId(fromToken),
    toOptionId: compareTokenToOptionId(toToken),
  };
};

export const serializeDesignOptionCompare = (
  search: string | null | undefined,
  compare?: DesignOptionCompareState
) => {
  const params = new URLSearchParams(normalizeCanvasSearch(search));
  if (!compare?.active) {
    params.delete(COMPARE_FROM_KEY);
    params.delete(COMPARE_TO_KEY);
  } else {
    params.set(COMPARE_FROM_KEY, optionIdToCompareToken(compare.fromOptionId));
    params.set(COMPARE_TO_KEY, optionIdToCompareToken(compare.toOptionId));
  }
  const next = params.toString();
  return next ? `?${next}` : "";
};
